import MicroTimeRangeInput from 'flow-doctor-lib/components/common/MicroTimeRangeInput';
import { ONE_MINUTE_MS, getTimestampFromSimpleDate, getTopOfDateTimestamp } from 'flow-doctor-lib/utils/dateTimeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * An abstraction over the `MicroTimeRangeInput` that handles timestamp conversion for us
 */
const TimestampedMicroTimeRangeInput = ({
  startTimestamp,
  endTimestamp,
  onStartTimestampChange,
  onEndTimestampChange,
  view,
  minTime,
  disabled,
  timezone = 'UTC'
}) => {
  return /*#__PURE__*/_jsx(MicroTimeRangeInput, {
    view: view,
    disabled: disabled,
    minTime: minTime,
    timezone: timezone,
    startTimestamp: startTimestamp,
    endTimestamp: endTimestamp,
    handleTimeChange: (timestampType, value) => {
      if (timestampType === 'startTimestamp') {
        onStartTimestampChange(getTopOfDateTimestamp(startTimestamp, timezone) + value * ONE_MINUTE_MS);
      } else {
        onEndTimestampChange(getTopOfDateTimestamp(endTimestamp, timezone) + value * ONE_MINUTE_MS);
      }
    },
    handleDateChange: (timestampType, value) => {
      const newTimestampValue = getTimestampFromSimpleDate(value, timezone);
      if (timestampType === 'startTimestamp') {
        onStartTimestampChange(newTimestampValue);
      } else {
        onEndTimestampChange(newTimestampValue);
      }
    },
    handleClear: () => {
      onStartTimestampChange(undefined);
      onEndTimestampChange(undefined);
    }
  });
};
export default TimestampedMicroTimeRangeInput;